// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import moment from 'moment'
// @end

// @import components
import {RelatedCoursesModuleLayout} from 'app_components/modules/campus/academic/relatedCourses'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import CourseService from 'app_services/campus/academic/courseService'
import { ICourse } from 'app_types/campus/academic/courseTypes'
// @end

// @import types
// @end

// @ADD Component types
interface IRelatedCoursesModuleProps {
  content: string
  title?: any
  exclude?: Array<string>
  initialNumberCarousel?: number
  breakpointItems?: RelatedCoursesModuleBreakItem[]
  hideFooterText?: boolean;
  className?: string;
  hideExtraInformation?: boolean
  hidePrice?: boolean
  size?: number
}
interface IRelatedCoursesModuleState {
  status: 'loading' | 'error' | null
  courses: Array<ICourse>
}

export interface RelatedCoursesModuleBreakItem{
  width: number | 'default';
  items: number;
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class RelatedCoursesModule extends Component<IRelatedCoursesModuleProps, IRelatedCoursesModuleState> {

  private nPerPage: number = 3;
  private courseService: CourseService;

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IRelatedCoursesModuleProps) {
    super(props)
    this.state = {
      courses: [],
      status: 'loading',
    }

    this.courseService = new CourseService()
    if (this.props?.size) {
      this.nPerPage = this.props.size
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.getList()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  getList = async (params?: any) => {

    this.setState({ status: 'loading' })

    let httpParams: any = {
      pageNumber: 1,
      startDate: {
        date: 'today',
        direction: 'gte'
      },
      random: {
        size: this.nPerPage
      },
      highlighted: true,
      publish: true,
    }

    if (this.props.exclude) {
      httpParams['exclude'] = this.props.exclude
    }

    const coursesResponse = await this.courseService.fetchCourses(httpParams)

    if (coursesResponse && coursesResponse.courses) {
      this.setState({
        courses: coursesResponse.courses,
        status: null
      })
    } else {
      this.setState({
        courses: [],
        status: null
      })
    }

  }

  render() {
    return(
      <RelatedCoursesModuleLayout
        content={this.props.content}
        courses={this.state.courses}
        status={this.state.status}
        title={this.props.title}
        initialNumberCarousel={this.props.initialNumberCarousel}
        breakpointItems={this.props.breakpointItems}
        hideFooterText={this.props.hideFooterText}
        className={this.props.className}
        hideExtraInformation={this.props.hideExtraInformation}
        hidePrice={this.props.hidePrice}
      />
    )
  }
}

export default connect(mapStatesToProps)(RelatedCoursesModule)
